/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useRef } from 'react';
import { Fade } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import deleteActionsIcon from 'assets/svg/deleteActionsIcon.svg';
import saveIcon from 'assets/svg/saveIcon.svg';

import { TableContainer } from 'app/styles';

import Icon from 'components/Tools/Icon';
import { Table } from 'components/Tools/Table';

import TableInput from '../TableInput';
import SwitchButton from '../SwitchButton';

import { ITableProps, IParameterData } from '../../types';

const ParametersTable: React.FC<ITableProps> = ({
  parametersData,
  handleSaveChanges,
  handleClearParameter,
  handleUpdateParameters,
}) => {
  const { t } = useTranslation();
  const indexRef = useRef<string | null>(null);

  return (
    <>
      <Fade in timeout={1000} unmountOnExit>
        <TableContainer>
          <Table<IParameterData>
            rows={parametersData}
            columns={[
              {
                title: String(t('screens.parameters.parameterDescription')),
                type: 'stringCenter',
                orderable: true,
                props: ['descricao'],
              },
              {
                title: String(t('screens.parameters.formattingDescription')),
                type: 'stringCenter',
                orderable: true,
                props: ['descricaoObservacao'],
              },
              {
                title: String(t('screens.parameters.editParameter')),
                type: 'stringCenter',
                orderable: true,
                props: ['descricaoObservacao'],
                renderItem: row => {
                  const isBooleanField =
                    row.descricaoObservacao?.includes('Sim') &&
                    row.descricaoObservacao?.includes('Não');

                  const handleChange = (value: string) => {
                    handleUpdateParameters(row, value);
                    indexRef.current = row.codigoParametro;
                  };

                  return (
                    <div
                      style={{
                        padding: '0 4px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1px',
                        margin: '0px 10px',
                      }}
                    >
                      {!isBooleanField ? (
                        <TableInput
                          minimum={0}
                          isFocused={row.codigoParametro === indexRef.current}
                          // @ts-ignore
                          onChange={(e: string | number) => {
                            handleChange(String(e));
                          }}
                          placeholder={String(t('screens.profileTable.edit'))}
                          value={row?.valor ?? ''}
                          type="text"
                        />
                      ) : (
                        <SwitchButton
                          id={row.codigoParametro}
                          label=""
                          isChecked={row.valor === 'S'}
                          handleInputChange={() => {
                            const newValue = row.valor === 'N' ? 'S' : 'N';
                            handleChange(newValue);
                          }}
                        />
                      )}
                    </div>
                  );
                },
              },
              {
                title: String(t('screens.profileTable.actions')),
                type: undefined,
                props: [''],
                renderItem: row => {
                  const isBooleanField =
                    !row.descricaoObservacao?.includes('Sim') &&
                    !row.descricaoObservacao?.includes('Não');

                  return (
                    <div className="row-actions-button-detail">
                      {isBooleanField && (
                        <button
                          type="button"
                          className="action"
                          onClick={() => {
                            handleClearParameter(row);
                            indexRef.current = row.codigoParametro;
                          }}
                        >
                          <img
                            src={deleteActionsIcon}
                            alt="editar"
                            style={{ width: '20px' }}
                          />
                          <p className="hover-item">
                            {t('screens.profileTable.edit')}
                          </p>
                        </button>
                      )}
                    </div>
                  );
                },
              },
            ]}
            exportList
            defaultNumberOfRows={50}
            habilityButtonAction
            selectBoxColor="#28CE6B"
            selectBoxHoverColor="#3aac67"
            selectBoxTitleColor="#fff"
            selectBoxActions={[
              {
                onClick: () => handleSaveChanges(),
                renderItem: () => (
                  <>
                    <Icon icon={saveIcon} color="#fff" height={14} width={26} />
                    <p>Salvar Parâmetros</p>
                  </>
                ),
              },
            ]}
          />
        </TableContainer>
      </Fade>
    </>
  );
};

export default ParametersTable;
